module.exports = __webpack_public_path__ + "static/media/transport-white.67ebfc48.svg";